import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';
import { NotFoundComponent, NotFoundConfig, NOT_FOUND_CONFIG } from './shared/error-pages';
import { PAGE_TITLE } from './shared/page-title';

import { AlreadyLoggedInGuard } from './guards/already-logged-in/already-logged-in.guard';
import { UserAuthenticatedGuard } from './guards/user-authenticated/user-authenticated.guard';

const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always'
};

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot([
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'login',
    },
    {
      path: 'admin',
      loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
      canActivate: [UserAuthenticatedGuard]
    },
    {
      path: 'app/:appId/client',
      loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
      canActivate: [UserAuthenticatedGuard],
      data: {
        [PAGE_TITLE]: 'Clients',
      }
    },
    {
      path: 'login',
      loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
      canActivate: [AlreadyLoggedInGuard],
      data: {
        [PAGE_TITLE]: 'Log in',
      }
    },
    {
      path: 'registration',
      loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule),
      data: {
        [PAGE_TITLE]: 'Register',
      }
    },
    {
      path: '**',
      component: NotFoundComponent,
      data: {
        [PAGE_TITLE]: 'Page not found',
        [NOT_FOUND_CONFIG]: <NotFoundConfig>{
          links: [
            {
              href: '/',
              label: 'Return to Home'
            },
          ]
        },
      }
    }
  ], routingConfiguration) ]
})
export class AppRoutingModule {
}
